import ITitles from '../../shared/interfaces/titles.interface';

export const TITLE_CLASS_ATTENDANCE: ITitles = {
    icon: 'checklist',
    title: 'Asistencia Pendiente',
    description: 'Consulta aqui la lista completa de clases de cualquier dia que selecciones para tomar asistencia de dias anteriores',
}